import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)

// Service worker registration is deliberately disabled. The previous worker
// intercepted /cdn-cgi/access/* — Cloudflare Access's auth callbacks — which a
// worker must never do. /sw.js is now a self-uninstalling stub so browsers
// that already have the old one drop it; actively unregister here too, for
// tabs that never navigate.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .getRegistrations()
    .then((regs) => regs.forEach((r) => void r.unregister()))
    .catch(() => {})
}
